import React from "react";
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  EditButton,
  TextInput,
  
  Filter,
  AutocompleteInput,
  TabbedForm,
  FormTab,

  CreateButton,
  RefreshButton,
  TopToolbar
} from "react-admin";
import Icon from "@material-ui/icons/LocalTaxi";


export const ClientIcon = Icon;

const ProjectTitle = ({ record }) => {
  return <span>Project {record ? `"${record.name}"` : ""}</span>;
};


export const PanelList = props => (
  <List {...props} exporter={false} bulkActionButtons={false}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="power" />
      <TextField source="width" />
      <TextField source="length" />
      <TextField source="height" />
      <EditButton label="" /> 
    </Datagrid>
  </List>
);


export const PanelCreate = props => (
  <Create title="Nov projekt" {...props} >
    <SimpleForm redirect="list">
        <TextInput source="name" />
        <TextInput source="width" />
        <TextInput source="length" />
        <TextInput source="height" />
        <TextInput source="power" />
    </SimpleForm>
  </Create>
);



export const PanelEdit = props => (
  <Edit title="Uredi projekt" {...props} >
    <SimpleForm redirect="list">
        <TextInput source="name" />
        <TextInput source="width" />
        <TextInput source="length" />
        <TextInput source="height" />
        <TextInput source="power" />
    </SimpleForm>
  </Edit>
);

